import { AvatarProps } from '@mui/material';
import { UiCustomerProfile } from '../../types';
import { AvatarName } from './AvatarName';

interface AvatarCustomerProps extends AvatarProps {
  customer: UiCustomerProfile | null | undefined;
}

export function AvatarCustomer({ customer, ...props }: AvatarCustomerProps) {
  return (
    <AvatarName
      {...props}
      src={customer?.picture ?? undefined}
      name={customer?.name ?? customer?.username ?? ''}
    />
  );
}
